import React, { useState } from 'react';
import { resetPassword } from '../services/auth.service';
import { useAuth } from '../contexts/AuthContext';
import { useNavigate } from 'react-router-dom';
import Button from '../components/Button';
import { getUrlParams } from '../services/parameter.service';
import Feedback from '../components/Feedback';

const ResetPassword: React.FC = () => {
  const [emailAddress, setEmailAddress] = useState('');
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [errors, setErrors] = useState([] as string[]);
  const [message, setMessage] = useState('');

  const navigate = useNavigate();

  const { code } = getUrlParams();

  const { isLoggedIn } = useAuth();

  const handleLogin = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    setErrors([]);
    if (password !== confirmPassword) {
      setErrors(['Passwords do not match']);
      return;
    }

    setLoading(true);
    const result = await resetPassword(emailAddress, code, password);
    if (result.success) {
      setMessage('Password changed.  Please log in again...');
      window.location.href = '/Account/Login?passwordChanged=true';
    } else {
      setErrors(result.errors);
    }
    setLoading(false);
  };

  if (isLoggedIn) {
    return <></>;
  }

  return (
    <div>
      <form onSubmit={handleLogin} className="login-form">
        <input
          type="text"
          id="username"
          placeholder="Email Address"
          required
          value={emailAddress}
          onChange={(e) => setEmailAddress(e.target.value)}
        />
        <input
          type="password"
          placeholder="Password"
          required
          value={password}
          onChange={(e) => setPassword(e.target.value)}
        />
        <input
          type="password"
          placeholder="Confirm Password"
          required
          value={confirmPassword}
          onChange={(e) => setConfirmPassword(e.target.value)}
        />
        <div className="button-container">
          <Button isLoading={loading} isSubmit={true}>
            Reset Password
          </Button>
          <Button type="Outline" onClick={() => navigate('/')}>
            Cancel
          </Button>
        </div>
        <Feedback messages={errors} type="error" />
        <Feedback message={message} type="success" />
      </form>
    </div>
  );
};

export default ResetPassword;
